<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Checklist" :tutorial="true" @startTutorial="startTutorial()"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box">
                <div :class="rightFrameOpen && correctWidth ? 'table-header space-between' : 'table-header space-between flex align-center'">
                    <p ref="scrollTo">Mai jos regăsești lista de documente necesare pentru a aplica la acest apel de finanțare</p>
                    <div class="legend" :style="rightFrameOpen && correctWidth ? {display: 'flex', 'align-content': 'stretch', 'justify-content': 'center', 'align-items': 'flex-start'} : {display: 'block'}">
                        <div class="checkbox-container">
                            <div class="check_box green" :style="rightFrameOpen && correctWidth ? {'margin-left': '10px'} : {'margin-left': 0}">
                                <input id="1" v-model="selected" type="checkbox" true-value="1" false-value="0">
                                <label for="1"></label>
                            </div>
                            <label class="nume-checkbox" for="1">Documente generate în <strong>POC</strong>Sketch®</label>
                        </div>
                        <div class="checkbox-container">
                            <div class="check_box purple" :style="rightFrameOpen && correctWidth ? {'margin-left': '10px'} : {'margin-left': 0}">
                                <input id="2" v-model="selected" type="checkbox" true-value="1" false-value="0">
                                <label for="2"></label>
                            </div>
                            <label class="nume-checkbox" for="2">Documente ale companiei</label>
                        </div>
                        <div class="checkbox-container">
                            <div class="check_box yellow" :style="rightFrameOpen && correctWidth ? {'margin-left': '10px'} : {'margin-left': 0}">
                                <input id="3" v-model="selected" type="checkbox" true-value="1" false-value="0">
                                <label for="3"></label>
                            </div>
                            <label class="nume-checkbox" for="3">Documente disponibile pentru descărcare</label>
                        </div>
                    </div>
                </div>
            </div>
            <b-overlay :show="documentLoading" class="customTable">
                <div>
                    <b-table id="TabelFisiere" hover responsive :fields="fields" head-variant="light">
                    </b-table>
                    <div v-for="(doc, index) in docs" :key="index">
                        <div class="tableHead" v-html="index"></div>
                        <b-table id="TabelFisiere" sticky-header hover responsive :items="doc" :fields="fields" thead-class="hidden_header">
                            <template v-slot:cell(name)="data">
                                <div class="relative">
                                    <span style="padding-left: 48px">{{ data.value }}</span>
                                    <div class="checkbox-container absolute-left">
                                        <div class="check_box" :class="data.item.special_generated ? 'yellow' : data.item.generated ? 'green': data.item.special ? 'red' : 'purple'">
                                            <input id="4" v-model="selected" type="checkbox" true-value="1" false-value="0">
                                            <label for="4"></label>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-slot:cell(ext)="data">
                                <span><strong>{{ data.value }}</strong></span>
                            </template>
                            <template v-slot:cell(incarca)="data">
                                <div v-if="!data.item.generated && !data.item.government || data.item.special_generated && !data.item.government" class="flex justify-content-center">
                                    <img v-if="data.item.special_generated" class="ml-1" src="@/assets/images/M3/M3Sketch/download-yellow.png">
                                    <b-icon-upload v-else-if="!data.item.block_upload" id="v-step-0" class="upload" @click="pickFile(data.item)"></b-icon-upload>
                                    <div v-if="data.item.value === 'imm'">
                                        <a :href="data.item.doc" download>
                                            <b-icon-download class="download" ></b-icon-download>
                                        </a>
                                    </div>
                                    <div v-if="data.item.files.file && !data.item.special_generated">
                                        <a v-if="data.item.value !== 'imm'" target="_blank" :href="prepareDownloadUrl(data.item)" download>
                                            <b-icon-download class="download" ></b-icon-download>
                                        </a>
                                        <b-icon-trash style="margin-left: 8px; cursor: pointer; font-size: 15px !important; color: #f44455;" @click="deleteFile(data.item.value)"></b-icon-trash>
                                    </div>
                                    <b-icon-x v-else-if="!data.item.special_generated" class="delete"></b-icon-x>
                                    <a v-if="data.item.files.file && data.item.special_generated" target="_blank" :href="prepareDownloadUrl(data.item)" download>
                                        <b-icon-download id="v-step-1" class="download" :class=" {yellow : data.item.special_generated }"></b-icon-download>
                                    </a>
                                </div>
                                <div v-else-if="data.item.government">
                                    <img v-if="data.item.special_generated" class="ml-1" src="@/assets/images/M3/M3Sketch/download-gov.png">
                                    <b-icon-upload v-else class="upload" @click="pickFile(data.item)"></b-icon-upload>
                                    <a v-if="data.item.files.file && !data.item.special_generated" target="_blank" :href="prepareDownloadUrl(data.item)" download>
                                        <b-icon-download class="download" ></b-icon-download>
                                    </a>
                                    <b-icon-x v-else-if="!data.item.special_generated" class="delete"></b-icon-x>
                                    <a v-if="data.item.files.file && data.item.special_generated" target="_blank" :href="prepareDownloadUrl(data.item)" download>
                                        <b-icon-download class="download" :class=" {blue : data.item.special_generated }"></b-icon-download>
                                    </a>
                                </div>
                                <img v-else-if="data.item.value !== 'imm_doc' && data.item.value !== 'aid_doc'" id="v-step-2" style="height: 20px;" src="@/assets/images/M3/M3Sketch/check-circle-fill.svg">
                                <div v-if="data.item.value === 'imm_doc' || data.item.value === 'aid_doc'">
                                    <img src="@/assets/images/M3/M3Sketch/info-icon-blue.png" alt="warn-sign" style="height: 20px;">
                                </div>

                            </template>
                            <template v-slot:cell(observatii)="data">
                                <div class="flex align-center justify-content-center">
                                    <span v-if="data.item.value === 'imm_doc'" class="blue-warn">Atenție! Nu generăm acest document!</span>
                                    <span v-else-if="data.item.value === 'aid_doc'" class="blue-warn">Atenție! Necesită completări suplimentare</span>
                                    <span v-else-if="data.item.name === 'Ofertă fundamentală costuri'">
                                        Descarcă șablonul <strong>POC</strong>Sketch® pentru repere
                                        <b-icon-cart-4 font-scale="1.2"></b-icon-cart-4>
                                    </span>
                                    <span v-else-if="data.item.value === 'financial_forecasts' && !data.item.files.file">Te rugăm să încarci documentul în pagina <router-link to="/aplicatii/m3-sketch/indicatori">indicatori</router-link></span>
                                    <span v-else v-html="checkDocumentUpload(data.item)"></span>
                                    <div v-if="data.item.files.filename">
                                        <b-icon-info-circle-fill :id="'fileName_' + data.item.files.id" class="ml-2"></b-icon-info-circle-fill>
                                        <b-tooltip :target="'fileName_' + data.item.files.id" triggers="hover" custom-class="customTooltip" placement="bottom">{{ data.item.files.filename }}</b-tooltip>
                                    </div>
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <v-tour name="checklistTour" :steps="steps" :options="tourOptions"></v-tour>
                </div>
            </b-overlay>
            <input ref="fileUpload" type="file" style="display:none" @change="uploadFile">
            <InfoChecklist></InfoChecklist>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>

    </div>
</template>

<script>
    import { BFormCheckbox, BTable, BIconUpload, BIconDownload, BIconX, BIconCart4, BIconTrash, BIconInfoCircleFill, BTooltip, BIconChevronUp, BOverlay } from 'bootstrap-vue'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import InfoChecklist from '@/pages/Aplicatii/M3/M3Sketch/components/InfoChecklist'
    import Vue from 'vue'
    import VueTour from 'vue-tour'
    Vue.use(VueTour)
    require('vue-tour/dist/vue-tour.css')
    export default {
        components: {
            SketchBreadcrumb,
            InfoChecklist,
            BFormCheckbox,
            BIconUpload,
            BIconDownload,
            BTable,
            BIconX,
            BIconTrash,
            BIconInfoCircleFill,
            BTooltip,
            BIconChevronUp,
            BOverlay,
            VueTour,
            BIconCart4
        },
        props: {
            rightFrameOpen: null,
        },
        data() {
            return {
                documentLoading: false,
                selected: 1,
                uploadedDocument:null,
                maxNumberOfFiles: 0,
                filesUploaded: 0,
                fields: [
                    {
                        key: 'name',
                        label: 'Document',
                    },
                    {
                        key: 'ext',
                        label: 'Model în anexă',
                    },
                    {
                        key: 'incarca',
                        label: 'Încarcă',
                        class: 'icons',
                    },
                    {
                        key: 'observatii',
                        label: 'Observații',
                    }
                ],
                steps: [
                    {
                        target: '#v-step-0',
                        header: {
                            title: 'Încarcă primul fișier',
                        },
                        content: `Apasă pe butonul de upload pentru a putea încărca fișierul necesar!`,
                        params: {
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-1',
                        header: {
                            title: 'Alte documente',
                        },
                        content: `De asemenea, poți descărca alte documente din acest loc.`,
                        params: {
                            enableScrolling: false
                        },
                    },
                    {
                        target: '#v-step-2',
                        header: {
                            title: 'Documente generate',
                        },
                        content: `Aceste documente sunt generate automat POCSketch. Le poți descărca după completarea datelor, din pagina "Dosarul tău complet".`,
                        params: {
                            placement: 'top',
                            enableScrolling: false
                        },
                    },
                ],
                tourOptions: {
                    labels: {
                        buttonSkip: 'Închide',
                        buttonPrevious: 'Înapoi',
                        buttonNext: 'Mai departe',
                        buttonStop: 'Finalizează'
                    }
                },
                docs: [],
                correctWidth: false,
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            filesUploaded(newValue, oldValue){
                if(newValue !== oldValue){
                    this.filesUploaded = newValue;

                    this.checkCompletedPage();
                }
            },
            allData(newValue, oldValue){
                if(newValue !== oldValue){
                    this.getDocumets();
                }
            },
        },
        mounted() {
            this.getDocumets();
            if(window.innerWidth < 1300)
                this.correctWidth = true;
        },
        methods: {
            startTutorial() {
                this.$tours['checklistTour'].start()
            },
            getDocumets(){
                let idCompanie =  JSON.parse(localStorage.getItem('currentM3Company')).id
                axios.get(api.API_ENDPOINTS.m3company + idCompanie + '/uploads')
                    .then( response => {
                        this.docs = response.data;
                        this.$store.dispatch('pageLoading/setLoading', false)
                        this.checkCompletedPage();
                        this.documentLoading = false
                    })
                    .catch( xhr => {
                        console.log(xhr);
                    })
            },
            checkDocumentUpload(doc){
                if(doc.special_generated){
                    if(doc.value === "financial_indicators_doc")
                        return 'Descarcă Excel indicatori financiari';
                    else
                        return 'Descarcă șablonul <strong>POC</strong>Sketch®';
                }
                if(doc.value === 'zip_offers'){
                    return 'Se va descărca o arhivă cu ofertele achizițiilor';
                }
                if(doc.generated){
                    return 'Document generat automat <strong>POC</strong>Sketch®';
                }
                if(!doc.files.file && doc.value !== 'financial_forecasts') {
                    return 'Te rugăm să încarci documentul'
                }
                if(!doc.files.file && doc.value === 'financial_forecasts') {
                    return 'Te rugăm să încarci documentul în pagina <router-link to="/aplicatii/m3-sketch/indicatori">indicatori</router-link>'
                }
                return 'Document încărcat cu succes'
            },
            pickFile(doc){
                let input = this.$refs.fileUpload;
                input.click()
                this.uploadedDocument = doc;
            },
            uploadFile(e) {
                if(e.target.files.length>0) {
                    let idCompanie = JSON.parse(localStorage.getItem('currentM3Company')).id
                    let form =  new FormData;
                    form.append('file', e.target.files[0]);
                    this.documentLoading = true
                    if(this.uploadedDocument)
                        form.append('location' ,this.uploadedDocument.value);
                    form.append('_method','PUT');
                    axios.post(api.API_ENDPOINTS.m3company + idCompanie + '/upload', form)
                        .then(response => {
                            let newDoc = this.docs['DOCUMENTELE COMPANIEI'].find( doc =>{
                                return doc.value === response.data.doc.value;
                            })

                            let indexChangedDoc = this.docs['DOCUMENTELE COMPANIEI'].indexOf(newDoc);
                            this.docs['DOCUMENTELE COMPANIEI'][indexChangedDoc].files.files = response.data.doc.path;
                            this.$toast.success(response.data.message);
                            this.getDocumets();
                            setTimeout(() => {
                                if(response.data.doc.value === '2019_balance'){
                                    this.$tours['checklistTour'].nextStep()
                                }
                            }, 1300)

                        }).catch(xhr => {
                            this.documentLoading = false
                            if (xhr.response.status === 422) {
                                this.$toast.error(xhr.response.data.errors.file[0]);
                            }
                        }).finally(() => {
                            this.uploadedDocument = null;
                            this.$refs.fileUpload.value = null;
                        });
                }
            },
            deleteFile(file){
                this.documentLoading = true
                axios.delete(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/delete/file/' + file)
                    .then(response => {
                        this.$toast.success(response.data.message);
                        this.getDocumets();
                        if(file === 'financial_forecasts'){
                            this.allData.financial_forecast_percent = null
                        }
                    }).finally(() => {
                        this.uploadedDocument = null;
                        this.$refs.fileUpload.value = null;
                    });
            },
            downloadFile(link){
                if(link){
                    location.href = link
                }
            },
            checkCompletedPage(){

                let section = {
                    section: 'checklist',
                    submit: true
                }

                if(this.docs['DOCUMENTELE COMPANIEI'][0].files.file && this.docs['DOCUMENTELE COMPANIEI'][1].files.file && this.docs['DOCUMENTELE COMPANIEI'][2].files.file && this.docs['DOCUMENTELE COMPANIEI'][3].files.file && this.docs['DOCUMENTELE COMPANIEI'][4].files.file && this.docs['DOCUMENTELE COMPANIEI'][5].files.file){
                    this.$store.dispatch('pages/addPage', section)
                }
                else{
                    this.$store.dispatch('pages/removePage', section)
                }
            },
            prepareDownloadUrl(doc){

                if(doc.files && doc.files.file) return doc.files.file
                return '#'
            },
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },

        }
    }
</script>

<style scoped>
.info-icon{
    max-width: 24px;
    top: -2px;
    left: 50px !important;
}
.blue-warn{
    font-size: 12px;
    color: #177dc1;
    font-weight: 600;
}
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.tableHead{
	background: #d6d8dd;
	padding: 5px 50px;
	color: #777e90;
	font-size: 12px;
	font-weight: bold;
}
.padding-box{
    padding: 20px 20px 0 20px;
}
.white-box{
    background: #fff;
    padding: 20px;
    padding-right: 120px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.justify-content-center{
    justify-content: center;
}
.table-header{
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
}
.checkbox-container {
    display: flex;
    pointer-events: none;
    align-items: center;
}
.checkbox-container:not(:last-child){
    margin-bottom: 10px;
}
.nume-checkbox {
    margin-left: 10px;
    color: #848484;
    cursor: pointer;
    font-size: 12px;
    margin-bottom: 0;
}
.check_box {
    display: flex;
    position: relative;
    pointer-events: none;
    height: fit-content;
}
.check_box input[type="checkbox"] {
    display: none;
}
.check_box label {
    position: relative;
    box-sizing: border-box;
    border: 0px solid #f2f1f2;
    width: 10px;
    height: 10px;
    transition: all 0.1s ease;
    z-index: 2;
    box-shadow: 0px 0px 0px 2px #f2f1f2;
    display: block;
    background: white;
    pointer-events: none;
    margin-bottom: 0;
}
.green input[type="checkbox"]:checked ~ label{
    background: #0cc2aa;
    border: 2px solid white;
}
.purple input[type="checkbox"]:checked ~ label{
    background: #6d0cc2;
    border: 2px solid white;
}
.red input[type="checkbox"]:checked ~ label{
    background: #f45369;
    border: 2px solid white;
}
.yellow input[type="checkbox"]:checked ~ label{
    background: #ffae0c;
    border: 2px solid white;
}

tbody span{
    color: #777e90;
    font-size: 12px;
    font-weight: 500;
}
tr{
    text-align: center !important;
}
.absolute-left{
    position: absolute;
    left: 10%;
    bottom: 40%;
    z-index: 0;
}
.icons svg:not(:last-child){
    margin-right: 10px;
}
.icons svg{
    font-size: 17px;
}
.icons .upload{
    color: #848484;
}
.icons .download{
    color: #0ce9c8;
}
.icons .download.yellow   {
    color: #ffae0c ;
}
.icons .download.blue   {
    color: #1a66fe ;
}
.icons .delete{
    color: #f44455;
    font-size: 19px;
}
.padding-box .table-responsive{
    overflow-y: auto;
    max-height: calc(100% - 122px);
}
.b-table-sticky-header, .table-responsive {
    margin-bottom: 0 !important;
}
.upload, .download{
    cursor: pointer;
}
.ml-1{
    margin-right: 10px;
}
.icons img{
    max-height: 20px;
}
.customTooltip >>> .tooltip-inner{
    max-width: 230px;
    padding: 4px 10px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.customTooltip >>> .arrow:before{
    border-width: 0 0.3rem 0.3rem;
    border-bottom-color: #eef2f9;
}
@media screen and (max-width: 1441px) {
  .white-box {
    padding-right: 40px;
  }
}
@media (max-width: 1300px){
    .absolute-left{
        left: -3px;
    }
    .white-box{
        padding-right: 20px;
    }
}
@media screen and (max-width: 1100px) {
    .white-box .table-header p {
        padding-right: 20px;
    }
}
</style>

<style>
#TabelFisiere  tbody tr {
    background-color: #ffffff!important;
}
.customTable .table td:first-child, .customTable .table th:first-child{
	width: 40%;
}
.customTable .table td:nth-child(2), .customTable .table th:nth-child(2){
	width: 15%;
}
.customTable .table td:nth-child(3), .customTable .table th:nth-child(3){
	width: 15%;
}
.customTable .table td:nth-child(4), .customTable .table th:nth-child(4){
	width: 30%;
}
.hidden_header {
	display: none !important;
}
.customTooltip .tooltip-inner{
    max-width: 230px;
    padding: 4px 10px;
    text-align: center;
    background: #eef2f9;
    color: #676d86;
    border-radius: 0.25rem;
}
.customTooltip .arrow:before{
    border-width: 0 0.3rem 0.3rem;
    border-bottom-color: #eef2f9;
}
#TabelFisiere tr{
    text-align: center !important;
    font-size: 14px !important;
}
#TabelFisiere tbody{
    max-height: 600px;
}
#TabelFisiere .relative{
    position: relative;
}
</style>
